/* eslint-disable no-unused-vars */
import { HttpErrorResponse, HttpResponseBase } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash';

const CODEMESSAGE: Record<number, unknown> = {
  200: 'The server successfully returned the requested data. ',
  201: 'New or modified data is successful. ',
  202: 'A request has entered the background queue (asynchronous task). ',
  204: 'Delete data successfully. ',
  400: 'The request was sent with an error, and the server did not perform operations to create or modify data. ',
  401: 'User has no permissions (token, username, password error). ',
  403: 'Users are authorized, but access is forbidden. ',
  404: 'The request sent is for a record that does not exist, and the server does not operate. ',
  406: 'The format of the request is not available. ',
  410: 'The requested resource is permanently deleted and will not be available again. ',
  422: 'A validation error occurred when creating an object. ',
  500: 'The server has an error. Please check the server. ',
  502: 'Gateway error. ',
  503: 'The service is unavailable, the server is temporarily overloaded or maintained. ',
  504: 'The gateway timed out. ',
};

export enum MessageType {
  ERROR,
  SUCCESS,
  INFO,
  WARNING
}
@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {
  successErrorMessages$ = new EventEmitter<any>();
  constructor(
    private injector: Injector,
    private notification: NzNotificationService,
    private translate: TranslateService
  ) {}

  get msg(): NzMessageService {
    return this.injector.get(NzMessageService);
  }

  private goTo(url: string) {
    setTimeout(() => this.injector.get(Router).navigateByUrl(url));
  }
  public constructorErrorMessageIfBlank(httpErrorResponse: HttpErrorResponse): string {
    if(httpErrorResponse.error.errors.length === 1 && httpErrorResponse.error.errors[0].message === '') {
      return `${this.checkStatus(httpErrorResponse)}`;
    }
    return '';
  }
  public checkStatus(ev: HttpResponseBase) {
    const errortext = CODEMESSAGE[ev.status] || ev.statusText;
    //console.error(errortext);
    return errortext;
  }
  public handleData(ev: HttpResponseBase): Observable<unknown> {
    // this.checkStatus(ev);
    // Business Processing: Some general operations
    switch (ev.status) {
      case 403:
        break;
      case 404:
        break;
      case 500:
        break;
      case 502:
        break;
    }
    return of(ev);
  }

  getErrorTabString(err: any) {
    let message = '';
    if (
      err &&
      err.errors &&
      typeof err.errors != 'string' &&
      err.errors.length
    ) {
      err.errors.forEach((v: any) => {
        if (v.arguments && v.arguments.property) {
          if (message) message += ', ';
          else message = 'Error in: ';
          message += v.arguments.property;
        }
      });
    }
    return message;
  }

  private showErrorMessage(msg: any) {
    let errors = this.getErrorList(msg);
    this.successErrorMessages$.next({ error: errors });
  }

  getErrorList(msg: any): Array<string> {
    let errors: any[] = [];
    if (msg?.errors && Array.isArray(msg?.errors)) {
      msg.errors.forEach((e: any) => {
        errors.push(e.message);
      });
    } else if (msg.message && Array.isArray(msg.message)) {
      msg.message.forEach((data: string) => {
        if (_.startsWith(data, '{')) {
          const key = data.replace('{', '').replace('}', '');
          errors.push(this.translate.instant(key));
        } else {
          errors.push(this.translate.instant(data));
        }
      });
    } else if (typeof msg === 'string') {
       errors = [msg] ;
    } else {
      errors = ['Server return error.'] ;
    }
    return errors;
  }

  getErrorListOfCode(msg: any): Array<string> {
    let errors: any[] = [];
    if (msg?.errors && Array.isArray(msg?.errors)) {
      msg.errors.forEach((e: any) => {
        errors.push(e.code);
      });
    } else if (msg?.code && Array.isArray(msg.code)) {
      msg.code.forEach((data: string) => {
        if (_.startsWith(data, '{')) {
          const key = data.replace('{', '').replace('}', '');
          errors.push(this.translate.instant(key));
        } else {
          errors.push(this.translate.instant(data));
        }
      });
    } else if (typeof msg === 'string') {
       errors = [msg] ;
    } else if (msg?.message && Array.isArray(msg?.message)){
       errors = msg.message;
    } else {
      errors = ['Server return error.'] ;
    }
    return errors;
  }

  private showSuccessMessage(msg: string) {
    this.successErrorMessages$.next({ success: msg });
  }

  hideSuccessMessage() {
    this.successErrorMessages$.next({ success: '' });
  }

  getMessages() {
    return this.successErrorMessages$;
  }

  showContentMessage(msg: any, type: MessageType, errorIndex?: number) {
    if (type === MessageType.ERROR) {
      // this.showErrorMessage(msg ,errorIndex); -- Original Code(Giving error)
      this.showErrorMessage(msg);
    } else if (type === MessageType.SUCCESS) {
      this.showSuccessMessage(msg);
    }
  }
  showTopFloatMessage(msg: any, type: MessageType, title = '') {
    switch (type) {
      case MessageType.ERROR:
        if (title.length > 0 && typeof msg === 'object' && msg?.message) {
          this.notification.error(title, msg?.message);
        } else if (title.length === 0 && typeof msg === 'object' && msg?.message) {
          this.msg.error(msg?.message);
        }
        else if (title.length > 0 && typeof msg === 'object' && msg?.errors) {
          this.notification.error(title, msg?.errors[0].message);
        } else if (title.length === 0 && typeof msg === 'object' && msg?.errors) {
          this.msg.error(msg?.errors[0].message);
        } else if (title.length === 0 && typeof msg === 'object' && msg?.errorMessages) {
          this.msg.error(msg.errorMessages[0].errorMessage);
        } else if (title.length > 0 && typeof msg === 'string') {
          this.notification.error(title, msg);
        } else if (title.length === 0 && typeof msg === 'string') {
          this.msg.error(msg);
        }
        break;
      case MessageType.SUCCESS:
        if (title.length > 0 && typeof msg === 'string') {
          this.notification.success(title, msg);
        } else if (title.length === 0 && typeof msg === 'string') {
          this.msg.success(msg);
        }
        break;
      case MessageType.INFO:
        if (title.length > 0 && typeof msg === 'string') {
          this.notification.info(title, msg);
        } else if (title.length === 0 && typeof msg === 'string') {
          this.msg.info(msg);
        }
        break;
      case MessageType.WARNING:
        if (title.length > 0 && typeof msg === 'string') {
          this.notification.warning(title, msg);
        } else if (title.length === 0 && typeof msg === 'string') {
          this.msg.warning(msg);
        }
        break;
    }
  }
}
